// extracted by mini-css-extract-plugin
export var active = "_80-b";
export var activeIndicator = "_80-6";
export var animate = "_80-a";
export var disabled = "_80-c";
export var flat = "_80-1";
export var fullWidth = "_80-3";
export var lg = "_80-9";
export var md = "_80-8";
export var redoButtonTabGroup = "_80-0";
export var sm = "_80-7";
export var tabButton = "_80-4";
export var tabButtonsContainer = "_80-2";
export var xs = "_80-5";